import { webWeights } from './WebWeights'

export const systemDenseWeights = {
  thin: webWeights.thin,
  light: webWeights.light,
  regular: webWeights.regular,
  semibold: webWeights.semibold,
  bold: webWeights.bold,
}
